module.exports = __webpack_public_path__ + "img/img5.76ebe89c.svg";